<script setup lang="ts">
import SkeletonBlock from './SkeletonBlock.vue'

withDefaults(defineProps<{ count?: number }>(), { count: 6 })
</script>

<template>
  <div class="sk-log-list" aria-busy="true" aria-label="日志加载中">
    <article v-for="i in count" :key="i" class="sk-log-item sk-surface">
      <div class="sk-log-item__head">
        <SkeletonBlock variant="button" width="52px" height="24px" inline />
        <SkeletonBlock variant="title" width="42%" class="sk-log-title" />
        <SkeletonBlock variant="button" width="64px" height="24px" inline />
      </div>
      <div class="sk-log-meta">
        <SkeletonBlock v-for="m in 4" :key="m" variant="text" width="22%" />
      </div>
      <div class="sk-log-actions">
        <SkeletonBlock variant="button" width="72px" inline />
        <SkeletonBlock variant="button" width="72px" inline />
      </div>
    </article>
  </div>
</template>

<style scoped>
.sk-log-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sk-log-item {
  padding: 16px 18px;
}

.sk-log-item__head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.sk-log-title {
  flex: 1;
  min-width: 120px;
}

.sk-log-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 12px;
}

.sk-log-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 575px) {
  .sk-log-meta {
    flex-direction: column;
    gap: 8px;
  }

  .sk-log-meta .sk-block {
    width: 100% !important;
  }
}
</style>
